<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <account-form :info="info" :current="current" :brandList="brandList" :storeList="storeList" :posList="posList"/>
      </div>
    </div>
  </section>
</template>

<script>
import accountForm from './Temp/AccountFormTemp.vue'

export default {
  name: 'Tables',
  data () {
    return {
      info: {},
      brandList: [],
      storeList: [],
      posList: [],
      current: {
        role_type: this.$route.params.role_type,
        manager_id: this.$route.params.manager_id
      }
    }
  },
  components: {
    'account-form': accountForm
  },
  methods: {
    getAccountInfo () {
      var self = this
      var url = '/manager/' + this.current.role_type + '/' + this.current.manager_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data.manager_info
          if (response.data.binding_brand_list) self.brandList = response.data.binding_brand_list
          if (response.data.store_list) self.storeList = response.data.store_list
          if (response.data.binding_pos_list) self.posList = response.data.binding_pos_list
        }
      })
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  },
  created () {
    this.getAccountInfo()
  }
}
</script>



// WEBPACK FOOTER //
// UpAccount.vue?d400c9a2